Object.defineProperty(exports,"__esModule",{value:true});var _platform=require("./../variables/platform");var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var checkBoxTheme={
".checked":{
"NativeBase.Icon":{
color:variables.checkboxTickColor},

"NativeBase.IconNB":{
color:variables.checkboxTickColor}},


"NativeBase.Icon":{
color:"transparent",
lineHeight:variables.CheckboxIconSize,
marginTop:variables.CheckboxIconMarginTop,
fontSize:variables.CheckboxFontSize},

"NativeBase.IconNB":{
color:"transparent",
lineHeight:variables.CheckboxIconSize,
marginTop:variables.CheckboxIconMarginTop,
fontSize:variables.CheckboxFontSize},

borderRadius:variables.CheckboxRadius,
overflow:"hidden",
width:variables.checkboxSize,
height:variables.checkboxSize,
borderWidth:variables.CheckboxBorderWidth,
paddingLeft:variables.CheckboxPaddingLeft-1,
paddingBottom:variables.CheckboxPaddingBottom,
left:10};


return checkBoxTheme;
};
//# sourceMappingURL=CheckBox.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/native-base/dist/src/theme/components/CheckBox.js
// module id = 428
// module chunks = 0